<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ accommodationLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field
              label="Name"
              v-model="a.name"
              @input="$v.a.name.$touch()"
              @blur="$v.a.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              label="Code"
              v-model="a.code"
              @input="$v.a.code.$touch()"
              @blur="$v.a.code.$touch()"
              :error-messages="codeErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm4>
            <v-text-field
              label="Std Occupancy"
              type="number"
              v-model.number="a.stdOccupancy"
              min="0"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              label="Min Occupancy"
              type="number"
              v-model.number="a.minOccupancy"
              min="0"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              label="Max Occupancy"
              type="number"
              v-model.number="a.maxOccupancy"
              min="0"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm4>
            <v-text-field
              label="Sales Nominal Code"
              v-model="a.salesNominalCode"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field
              label="Purchase Nominal Code"
              v-model="a.purchaseNominalCode"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm4>
            <taxes-list-select
              :taxCode="a.taxCode"
              @onSelectTaxType="onSelectTaxType($event)"
              :doResetSelectedTax="doResetSelectedTax"
              @onSelectedTaxReset="onSelectedTaxReset"
              :outlined="outlinedInputs"
            ></taxes-list-select>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col>
            <v-switch label="Not In Use" v-model="a.notInUse"></v-switch>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <div v-if="debug">{{ a }}</div>
  </v-content>
</template>

<script>
import {
  ACCOMMODATION_SERVICE_TYPE_UPDATE_MUTATION,
  ACCOMMODATION_SERVICE_TYPE_CREATE_MUTATION,
} from "../../../../constants/graphql";
import { required } from "vuelidate/lib/validators";
import TaxesListSelect from "../../shared/TaxesListSelect";

export default {
  name: "RoomEditor",

  components: {
    TaxesListSelect,
  },

  props: {
    accommodation: {
      type: Object,
      default: () => ({}),
    },

    doSaveAccommodation: {
      type: Boolean,
      default: false,
    },

    accommodationEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      a: { ...this.accommodation },
      debug: false,
      doResetSelectedTax: false,
    };
  },

  methods: {
    saveAccommodation() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? ACCOMMODATION_SERVICE_TYPE_UPDATE_MUTATION
            : ACCOMMODATION_SERVICE_TYPE_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.a,
            },
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.resetSelectedTax();
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
    onSelectTaxType(data) {
      this.a.taxCode = data.code;
    },
    resetSelectedTax() {
      this.doResetSelectedTax = true;
    },
    onSelectedTaxReset() {
      this.doResetSelectedTax = false;
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    accommodationLabel() {
      return this.accommodation.id != null
        ? this.accommodation.name
        : "New Accommodation Service Type";
    },
    context() {
      return this.accommodation.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.a.name.$dirty) {
        return errors;
      }
      if (!this.$v.a.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    codeErrors() {
      let errors = [];
      if (!this.$v.a.code.$dirty) {
        return errors;
      }
      if (!this.$v.a.code.required) {
        errors.push("Code is required.");
      }
      return errors;
    },
  },
  watch: {
    accommodation(data) {
      let accommodation = { ...data };
      delete accommodation.__typename;
      this.a = accommodation;
    },
    accommodationEditorDialog(value) {
      if (!value) {
        this.a = {};
        this.resetSelectedTax();
        this.$v.$reset();
      }
    },
    doSaveAccommodation(value) {
      if (value) {
        this.saveAccommodation();
      }
    },
  },

  validations: {
    a: {
      name: { required },
      code: { required },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/RoomEditor.vue